import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import Layout from './components/Layout';
import ExpiringCertificates from './pages/ExpiringCertificates';
import AllCertificates from './pages/AllCertificates';
import './App.css';
import logo from './assets/Tekpro-logo.png';  // Correct path to the image in src

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  const [domains, setDomains] = useState([]);

  const checkSSLUrl = 'https://prod-21.centralindia.logic.azure.com:443/workflows/745d4acf0561479e952c4e601827158b/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=2UJaMZkEnCaXucYkBV_4kNX4fFX7hMfA4ZqICohYPsw';
  const getDomainsUrl = 'https://prod-30.centralindia.logic.azure.com:443/workflows/4e5f65610bf246b8af8bd791704ae0af/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=DjFwFBCLYMquIqPS9yZEoroP_NmqL84rMzQ2Cl_ME1w';
  const deleteDomainUrl = 'https://prod-20.centralindia.logic.azure.com:443/workflows/30d3fa6ec4214d05abe4ef4cca0097ba/triggers/When_a_HTTP_request_is_received/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2FWhen_a_HTTP_request_is_received%2Frun&sv=1.0&sig=-poycM7VzJAHz9nsiz2IsxQaeAxPBVrAWMxP-_mK7bQ';

  const fetchDomains = async () => {
    try {
      const response = await fetch(getDomainsUrl);
      const data = await response.json();
      if (Array.isArray(data.domains)) {
        setDomains(data.domains);
      } else if (Array.isArray(data)) {
        setDomains(data);
      } else {
        setDomains([]);
      }
    } catch (error) {
      console.error('Error fetching domains:', error);
      setDomains([]);
    }
  };

  const addDomain = async ({ domain, customer }) => {
    try {
      await fetch(checkSSLUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ domain, customer })
      });
      setTimeout(fetchDomains, 3000);
    } catch (error) {
      console.error('Error adding domain:', error);
    }
  };

  const deleteDomain = async (domain) => {
    if (!window.confirm(`Delete ${domain}?`)) return;
    try {
      await fetch(deleteDomainUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ domain })
      });
      setTimeout(fetchDomains, 1000);
    } catch (error) {
      console.error('Error deleting domain:', error);
    }
  };

  useEffect(() => {
    fetchDomains();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={
              <ExpiringCertificates
                domains={domains}
                onAddDomain={addDomain}
                onDeleteDomain={deleteDomain}
                onRefresh={fetchDomains}
              />
            } />
            <Route path="all" element={
              <AllCertificates
                domains={domains}
                onAddDomain={addDomain}
                onDeleteDomain={deleteDomain}
                onRefresh={fetchDomains}
              />
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
